module.exports = __webpack_public_path__ + "img/icon-instagram.d5ff73ff.svg";